import { jsx as _jsx } from "react/jsx-runtime";
import { ExtensibleAccordion } from "../components/extensibleAccordion";
import { ShellServiceIdentity } from "./shellService";
import { SettingsRegular } from "@fluentui/react-icons";
import { useObservableCollection, useOrderedObservableCollection } from "../hooks/observableHooks";
import { ObservableCollection } from "../misc/observableCollection";
/**
 * The unique identity symbol for the settings service.
 */
export const SettingsServiceIdentity = Symbol("SettingsService");
export const SettingsServiceDefinition = {
    friendlyName: "Settings",
    consumes: [ShellServiceIdentity],
    produces: [SettingsServiceIdentity],
    factory: (shellService) => {
        const sectionsCollection = new ObservableCollection();
        const sectionContentCollection = new ObservableCollection();
        const registration = shellService.addSidePane({
            key: "Settings",
            title: "Settings",
            icon: SettingsRegular,
            horizontalLocation: "right",
            verticalLocation: "top",
            order: 500,
            teachingMoment: false,
            content: () => {
                const sections = useOrderedObservableCollection(sectionsCollection);
                const sectionContent = useObservableCollection(sectionContentCollection);
                return _jsx(ExtensibleAccordion, { sections: sections, sectionContent: sectionContent, context: true });
            },
        });
        return {
            addSection: (section) => sectionsCollection.add(section),
            addSectionContent: (content) => sectionContentCollection.add(content),
            dispose: () => {
                registration.dispose();
            },
        };
    },
};
//# sourceMappingURL=settingsService.js.map